import { Component, OnInit } from '@angular/core';
import { NumericFormControl } from './numeric.control';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-numeric-control',
  templateUrl: './bs-app-launch-numeric-control.component.html',
  styleUrls: ['./bs-app-launch-numeric-control.component.scss'],
})
export class BsAppLaunchNumericControlComponent extends BsAppLaunchFormControlBaseComponent<NumericFormControl> implements OnInit {
  formControl: NumericFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit(): void {}

  onBlur(): void {
    this.checkAndFireFormUpdate();
  }

}
